import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Chip, IconButton, Typography } from '@mui/material';
import type React from 'react';
import type { DisplayUser } from './types';

interface UserDetailsHeaderProps {
  user: DisplayUser;
  canEditUser: boolean;
  isSaving: boolean;
  onSave: () => void;
  onBack: () => void;
}

export const UserDetailsHeader: React.FC<UserDetailsHeaderProps> = ({
  user,
  canEditUser,
  isSaving,
  onSave,
  onBack,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton onClick={onBack} sx={{ mr: 2 }}>
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
            {user.displayName || user.email}
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            {user.status === 'pending' ? (
              <Chip label="Pending Onboarding" color="warning" size="small" variant="filled" />
            ) : user.disabled ? (
              <Chip label="Inactive" color="default" size="small" />
            ) : (
              <Chip label="Active" color="success" size="small" />
            )}
          </Box>
        </Box>
      </Box>
      {canEditUser && (
        <Button variant="contained" color="primary" onClick={onSave} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save Changes'}
        </Button>
      )}
    </Box>
  );
};
